import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const StyledFullWidthDiv = styled.div`
  justify-self: center;
  width: 100%;

  .form-header {
    text-align: center;
    font-size: 42px;
    color: #272727;
    font-family: 'Whitney Book';
    font-weight: 300;

    @media (max-width: 600px) {
      font-size: 30px;
    }
  }
`;

const StyledDiv = styled.div`
  justify-self: center;
  width: 100%;

  .form-header {
    text-align: center;
    font-size: 42px;
    color: #272727;
    font-family: 'Whitney Book';
    font-weight: 300;

    @media (max-width: 600px) {
      font-size: 30px;
    }
  }
  @media (max-width: 600px) {
    max-width: 500px;
  }
`;

export const ProgressBar = ({
  sections,
  currentSection,
  headerText,
  displayFullWidth,
}) => {
  const indexOfCurrentSection = sections.findIndex(
    (section) => section.name === currentSection
  );

  if (displayFullWidth) {
    return (
      <StyledFullWidthDiv>
        <p className="form-header">{headerText}</p>
        <div className="progress-bar">
          <ul className="wizard-progress">
            {sections.map((section, index) => {
              const oneBasedIndex = index + 1;
              const stepIsComplete = indexOfCurrentSection > index;

              // For mobile views we want to show the section names above and below the line in order to make
              // better use of the limited viewport width

              if (oneBasedIndex % 2 == 1) {
                // odd numbered section
                return (
                  <li
                    key={section.name}
                    className={classnames({
                      active: currentSection == section.name,
                      complete: stepIsComplete,
                    })}
                  >
                    <div className="bubble full-width">
                      {stepIsComplete ? (
                        <FontAwesomeIcon icon={faCheck} />
                      ) : (
                        oneBasedIndex
                      )}
                    </div>
                    <div className="title">{section.label}</div>
                  </li>
                );
              } else {
                // even numbered section
                return (
                  <li
                    key={section.name}
                    className={classnames({
                      active: currentSection == section.name,
                      complete: stepIsComplete,
                    })}
                  >
                    <div className="display-top title">{section.label}</div>
                    <div className="bubble full-width bubble-mobile">
                      {stepIsComplete ? (
                        <FontAwesomeIcon icon={faCheck} />
                      ) : (
                        oneBasedIndex
                      )}
                    </div>
                    <div className="display-bottom title">{section.label}</div>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </StyledFullWidthDiv>
    );
  }

  return (
    <StyledDiv>
      <p className="form-header">{headerText}</p>
      <div className="progress-bar">
        <div className="row align-center">
          <div className="small-12 medium-8 columns">
            <ul className="wizard-progress">
              {sections.map((section, index) => {
                const oneBasedIndex = index + 1;
                const stepIsComplete = indexOfCurrentSection > index;

                // For mobile views we want to show the section names above and below the line in order to make
                // better use of the limited viewport width

                if (oneBasedIndex % 2 == 1) {
                  // odd numbered section
                  return (
                    <li
                      key={section.name}
                      className={classnames({
                        active: currentSection == section.name,
                        complete: indexOfCurrentSection > index,
                      })}
                    >
                      <div className="bubble">
                        {stepIsComplete ? (
                          <FontAwesomeIcon icon={faCheck} />
                        ) : (
                          oneBasedIndex
                        )}
                      </div>
                      <div className="title">{section.label}</div>
                    </li>
                  );
                } else {
                  // even numbered section
                  return (
                    <li
                      key={section.name}
                      className={classnames({
                        active: currentSection == section.name,
                        complete: indexOfCurrentSection > index,
                      })}
                    >
                      <div className="display-top title">{section.label}</div>
                      <div className="bubble bubble-mobile">
                        {stepIsComplete ? (
                          <FontAwesomeIcon icon={faCheck} />
                        ) : (
                          oneBasedIndex
                        )}
                      </div>
                      <div className="display-bottom title">
                        {section.label}
                      </div>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </div>
      </div>
    </StyledDiv>
  );
};
